import { useMatch } from 'react-router';
import { selectUserGuid, useAppSelector } from '../../slices/commonSelectors';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from '../../constants/apiConfig';

import { isUUID } from '../../utils/isUUID';

export const useFocusedUser = () => {
  const profileEditMatch = useMatch({ path: '/profile/:user_guid' });

  const focusedUserGuid = profileEditMatch?.params.user_guid;

  const userGuid = useAppSelector(selectUserGuid);

  return useQuery({
    queryKey: ['focused_user', focusedUserGuid],
    queryFn: async () => {
      const res = await axios(config.apiGateway.getUserById, {
        method: 'POST',
        data: JSON.stringify({
          focus_user_id: focusedUserGuid,
        }),
      });
      return res.data;
    },
    enabled: isUUID(focusedUserGuid) && focusedUserGuid !== userGuid,
  });
};
